module.exports = __webpack_public_path__ + "img/h2ha.bd51a8f0.svg";